import { Car, CircleHelp, DoorOpen, Fingerprint, Lightbulb, MessageSquare, QrCode, ShieldCheck, Siren, Smartphone } from "lucide-react";

const ICONS = { Car, CircleHelp, DoorOpen, Fingerprint, Lightbulb, MessageSquare, QrCode, ShieldCheck, Siren, Smartphone };

export const Icon = ({ name, ...props }) => {
  const Cmp = ICONS[name] || CircleHelp;
  return <Cmp aria-hidden="true" {...props} />;
};
